"use client";
import { useQuranOptions } from "@/app/providers/QuranContextProvider";
import { QuranWord } from "./quran-word";
import { cn } from "@/lib/helpers/utils";

const hafsPreview: any[] = [
  {
    id: 11,
    page: 1,
    surah: 0,
    verse: 0,
    word: 1,
    verse_id: 3,
    text_uthmani: "ٱلرَّحْمَـٰنِ",
    code_v2: "ﱋ",
    code_v1: "ﭛ",
    uthmani_hafs: "ٱلرَّحۡمَٰنِ",
    type: "word",
    word_text: "ﱋ",
  },
  {
    id: 12,
    page: 1,
    surah: 0,
    verse: 0,
    word: 2,
    verse_id: 3,
    text_uthmani: "ٱلرَّحِيمِ",
    code_v2: "ﱌ",
    code_v1: "ﭜ",
    uthmani_hafs: "ٱلرَّحِيمِ",
    type: "word",
    word_text: "ﱌ",
  },
  {
    id: 13,
    page: 1,
    surah: 0,
    verse: 0,
    word: 3,
    verse_id: 3,
    text_uthmani: "٣",
    code_v2: "ﱍ",
    code_v1: "ﭝ",
    uthmani_hafs: "٣",
    type: "end",
    word_text: "ﱍ",
  },
];

const indoPakPreview: any[] = [
  {
    id: 11,
    verse_id: 3,
    surah: 0,
    verse: 0,
    word: 1,
    type: "word",
    words_text: "الرَّحْمٰنِ",
  },
  {
    id: 12,
    verse_id: 3,
    surah: 0,
    verse: 0,
    word: 2,
    type: "word",
    words_text: "الرَّحِیْمِ",
  },
  {
    id: 13,
    verse_id: 3,
    surah: 0,
    verse: 0,
    word: 3,
    type: "end",
    words_text: "۟ۙ",
  },
];

export default function QuranFontPreview() {
  const { quranFont, quranFontSize } = useQuranOptions();
  const toPreview = quranFont == "indo-pak" ? indoPakPreview : hafsPreview;

  return (
    <div
      // ref={ref}
      className={cn(
        "flex flex-row cursor-default leading-loose rtl justify-center items-center h-full",
      )}
      style={{
        direction: "rtl",
        fontSize: `${quranFont == "hafs1" ? quranFontSize + 0.5 : quranFont == "indo-pak" ? quranFontSize + 0.2 : quranFontSize}rem`,
      }}
    >
      {toPreview.map((word, i) => (
        <QuranWord key={`view-${i}`} preview={true} word={word} />
      ))}
    </div>
  );
}
